export default class CityShowcase {
  constructor (initialData = {},) {
    const {
      city,
      grids,
      ...rest
    } = initialData;

    this.address = this.normalizeAddress(city,);
    this.sortings = this.normalizeSortings(grids,);

    Object.assign(this, rest,);
  }

  normalizeSortings (sortings = [],) {
    if (!Array.isArray(sortings,)) {
      return [];
    }


    return sortings.map((sorting,) => {
      const enabled = this.normalizeUser(sorting.enabled,);

      return {
        id: sorting.id || sorting._id,
        _id: sorting._id || sorting.id,
        address: this.address,
        franchise_id: sorting.franchise_id || null,
        name: sorting.name || '',
        stores: this.normalizeStores(sorting.stores,),
        created: this.normalizeUser(sorting.created, sorting.created_at,),
        updated: this.normalizeUser(sorting.updated, sorting.updated_at,),
        enabled,
        status: this.getGridStatus(enabled,),
      };
    },);
  }

  normalizeAddress (address = {},) {
    return {
      city: address?.city || address?.name ||'',
      state: address?.state || '',
      city_id: Number(address?.city_id || address?.id || 0,),
    };
  }

  normalizeStores (stores = [],) {
    if (!Array.isArray(stores,)) {
      return [];
    }

    return stores.
      map((store, index,) => ({
        company_uuid: store?.company_uuid || null,
        name: store?.name || null,
        position: Number(store?.position || index + 1,),
        financial_status: store?.financial_status || null,
        image: store?.image ? store.image.split('https://static.deliverymuch.com.br/images/stores/',).at(-1,) : '',
        publish_status: store?.publish_status || null,
        score: store?.score || null,
        address: this.normalizeAddress(store.address,),
      }),).
      sort((a, b,) => a.position - b.position,);
  }

  normalizeUser (user = {}, date,) {
    return {
      _id: user?._id,
      id: user?.id,
      date: date || user?.date,
      name: user?.name,
      status: Boolean(user?.status,),
    };
  }

  getGridStatus (enabled,) {
    if(enabled?.status && enabled?.date) {
      return 'ENABLED';
    }

    if(!enabled?.status && enabled?.date) {
      return 'DISABLED';
    }

    return 'CREATED';
  }
}
